import { render, staticRenderFns } from "./AnalysisAvailableClinics.vue?vue&type=template&id=ac876c0c&scoped=true&"
import script from "./AnalysisAvailableClinics.vue?vue&type=script&lang=ts&"
export * from "./AnalysisAvailableClinics.vue?vue&type=script&lang=ts&"
import style0 from "./AnalysisAvailableClinics.vue?vue&type=style&index=0&id=ac876c0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac876c0c",
  null
  
)

export default component.exports